import { useCallback, useEffect, useState } from 'react'
import { Proposal } from '../../shared/types'
import { ProposalsApi } from '../../../api/proposals-api'

export default function useIssuerProposal(proposalId?: string | null) {
  const [proposal, setProposal] = useState<Proposal | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<unknown>()

  const loadProposal = useCallback(async () => {
    if (!proposalId) return
    setLoading(true)
    try {
      const data = await ProposalsApi.getIssuerProposal(proposalId)
      setProposal(data)
      setError(undefined)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [proposalId])

  useEffect(() => {
    void loadProposal()
  }, [loadProposal])

  return { proposal, loading, error, reload: loadProposal }
}
